
import { Vue, Component, Watch } from "vue-property-decorator";
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import TextField from "@/components/common/TextField.vue";
import AeAutocomplete from "@/components/common/Autocomplete.vue";
import Autocomplete from "@/components/common/Autocomplete.vue";
import {ValidationError} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";
import { DynamicDetailEntry } from "@/app/dynamic-components/details/dynamic-detail.model";

type AddressFormMetaData = {
  allowCoordinates: boolean;

  itemText: string;
  itemValue: string;
  translate: boolean;

  ignoreValidationHouseNumber: boolean;

  coutries: any
};

@Component({
  components: {DynamicComponentConfigManager, Autocomplete, TextField, AeAutocomplete },
})
export default class AddressFormBase extends BaseDynamicComponent<AddressFormMetaData> {
  isAddressAvailble = true;

  _countries : any[] | undefined = undefined;
  private getCountries(){
    this._countries = undefined;
    let countries = this.entry?.metadata?.countries;
    if( !countries ) return undefined;
    if (typeof countries === 'string' && countries.startsWith('data.')){
      const resolvedList = this.entry?.root?.resolveFieldValue(countries);
      if(resolvedList && resolvedList != '$nan'){
        countries = resolvedList;
      }
    }
    if(Array.isArray(countries)){
      this._countries = countries;
      return;
    }
    if(typeof countries === 'object'){
      this._countries = [];
      Object.entries(countries).forEach(([key,value]) => {
        this._countries?.push({key: key, value: value})
      });
      return;
    }
  }

  postEntityChanged(newValue: DynamicDetailEntry) {
    this.getCountries();
  }

  public addressTop() {
    if (!this.value) return "-";
    return (
        (this.value["street"] || "-") +
        " " +
        (this.value["number"] || "-") +
        (this.value["box"] || "")
    );
  }

  public addressBottom() {
    if (!this.value) return "";
    return (
        (this.value["postalCode"] || "") +
        " " +
        (this.value["municipality"] || "") //+
        //" " +
        //(this.getTranslatedCountry(this.value["country"]) || "")
    );
  }

  public getTranslatedCountry(country: string): string {
    if(!country) return "";
    if(!this._countries) {
      return this.metadata?.translate ? this.$tc(country) : country;
    }
    if(!this.metadata) return country;

    if(!this.metadata?.itemText || !this.metadata?.itemValue) {
      return this.metadata?.translate ? this.$tc(country) : country;
    }

    const foundCountries = this._countries.find(value => value[this.metadata?.itemValue || ''] === country);
    if(!foundCountries || foundCountries.length <= 0) return country;
    return this.metadata?.translate ? this.$tc(foundCountries[0][this.metadata?.itemText || '']) : foundCountries[0][this.metadata?.itemText || ''];
  }


  public getDefaultValue(): any {
    return {
      country: '',
      municipality: '',
      postalCode: '',
      street: '',
      number: '',
      box: ''
    };
  }

  mounted(): void {
    this.value = {
      country: '',
      municipality: '',
      postalCode: '',
      street: '',
      number: '',
      box: ''
    };
  }

  onSelectContentChanged(newValue: unknown, valueKey: string) {
    if (this.value == null) {
      this.setValueView({
        country: '',
        municipality: '',
        postalCode: '',
        street: '',
        number: '',
        box: ''
      });
    }
    this.value[valueKey] = newValue;
    if(this.value.number === undefined || this.value.number === null || this.value.number === ''){
      this.value.number = null;
    }
  }

  onSelectValidityChanged(isValid: boolean) {
    return;
  }

  onAddressAvailableChange() {
    if (this.isAddressAvailble) {
      this.value["latitude"] = null;
      this.value["longitude"] = null;
    } else {
      this.value["street"] = null;
      this.value["number"] = null;
      this.value["box"] = null;
    }
  }

  public async fillIndexerValue(indexerField: string, indexerSelector): Promise<any> {
    if(indexerField.startsWith('t')){
      if (!this.value || !this.value["municipality"]) return "";
      return (this.value["country"] || "") + " " + (this.value["postalCode"] || "") + " " + (this.value["municipality"] || "") + " " + (this.value["street"] || "") + " " + (this.value["number"] || "") + "" + (this.value["box"] || "")
    }
    if(indexerField.startsWith('n')){
      if (!this.value || !this.value["municipality"]) return "";
      return this.value && this.value["postalCode"] ? Number.parseInt(this.value["postalCode"]) : 0
    }
    if(indexerField.startsWith('b')){
       return this.value && this.value["municipality"];
    }
    return undefined;
  }


  async getEmbeddedErrors(): Promise<ValidationError[]> {
    return [];
  }
}
